const API_BASE_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, '');

export type SkillSearchResult = {
  id: string;
  preferredLabel: string;
  altLabels: string[];
  description?: string;
  conceptUri?: string;
  groupCode?: string;
  region?: string;
};

export async function searchSkills(query: string): Promise<SkillSearchResult[]> {
  if (!API_BASE_URL) return [];
  const trimmed = query.trim();
  if (!trimmed || trimmed.length < 2) return [];

  const url = new URL(`${API_BASE_URL}/v1/skills/search`);
  url.searchParams.set('q', trimmed);

  const response = await fetch(url.toString(), { headers: { 'Content-Type': 'application/json' } });
  if (!response.ok) {
    const text = await response.text().catch(() => 'request failed');
    throw new Error(`Skills search failed (${response.status}): ${text}`);
  }

  const payload = (await response.json()) as { results?: SkillSearchResult[] };
  return payload.results ?? [];
}
